import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './TopPicksPopup.css';
import React, { useState, useEffect } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import IconClosePrimary from '../../components/atoms/Icons/IconClosePrimary';
import Cookies from 'js-cookie';
var TopPicksPopup = function TopPicksPopup(_ref) {
  var _ref$copy = _ref.copy,
    copy = _ref$copy === void 0 ? 'Add items to your Top Picks by clicking content with the heart as you navigate through the website' : _ref$copy,
    _ref$modifier = _ref.modifier,
    modifier = _ref$modifier === void 0 ? '' : _ref$modifier;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var TopPicksCookieName = 'top_picks_popup';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  useEffect(function () {
    if (Cookies.get(TopPicksCookieName) === undefined) {
      setShow(true);
    }
  }, []);
  var closePopup = function closePopup() {
    Cookies.set(TopPicksCookieName, JSON.stringify({
      processed: 'true'
    }), {
      expires: 999,
      secure: true
    });
    setShow(false);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    modifier: modifier
  }, /*#__PURE__*/React.createElement("div", {
    className: "tp-popup  ".concat(show ? 'tp-popup--show' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "tp-popup__close",
    onClick: closePopup,
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.target.click();
      }
    }
  }, /*#__PURE__*/React.createElement(IconClosePrimary, {
    className: "tp-popup__close-icon"
  })), /*#__PURE__*/React.createElement("p", {
    className: "body-medium"
  }, copy)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    modifier = _ref2.modifier;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(modifier, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "c1e70pzo";
var ltrStyles = "ldrdbzy";
var rtlStyles = "rxv9iiw";
export default TopPicksPopup;